import type { Task } from '@src/features/tasks/types';

export function canEditTaskOnFrontend(
  task: Task,
  currentUserId: number | string | null | undefined,
) {
  if (!currentUserId) {
    return false;
  }

  const normalizedUserId = Number(currentUserId);
  const isAssignedUser = task.taskUser.id === normalizedUserId;
  const isTaskAuthor = task.author?.id === normalizedUserId;

  return task.canEdit && (isAssignedUser || isTaskAuthor);
}

export function isTaskFieldEditable(task: Task, field: string) {
  return task.editableFields.includes(field);
}
